import { resolveUser, updateUser } from "@/api/atm-back";
import { listUser } from "@/api/user-management-back";
import User from "@/models/User";
import { defineStore } from "pinia";
import { useRepo } from "pinia-orm";

const UserRepo = useRepo(User);

export const useUserStore = defineStore("user", {
  state: () => ({
    currentUser: null,
  }),

  getters: {
    getAllUsers: () => {
      return UserRepo.all();
    },
    getUserByUuid: () => {
      return (uuid) => {
        return UserRepo.find(uuid);
      };
    },
  },

  actions: {
    async initializeCurrentUser() {
      try {
        const userData = await resolveUser();
        this.currentUser = UserRepo.insert({
          ...userData,
          isCurrentUser: true,
        });
      } catch (err) {
        console.error(err);
      }
    },

    async updateCurrentUser(userData) {
      // L.B 21/07/26 The REST patch is keyed by usermanagement_uuid (resolved from the
      // loaded current user); read-only fields in userData are dropped server-side.
      const userDataResponse = await updateUser(this.currentUser.usermanagementUuid, userData);
      UserRepo.insert(userDataResponse);

      this.currentUser = new User({
        ...this.currentUser,
        ...userDataResponse,
      });
      return userDataResponse;
    },

    async searchUser(text) {
      const userDataResponse = await listUser({ search: text });
      UserRepo.insert(userDataResponse.results);
      return UserRepo.where((user) =>
        userDataResponse.results.some((result) => result.id === user.id),
      ).get();
    },
  },
});
